export const palette = {
  white: '#ffffff',
  black: '#000000',

  gray25: '#2c3235',
  gray15: '#22252b', //'#202226',
  gray10: '#181b1f', // old '#141619',
  gray05: '#111217', // old '#0b0c0e',

  // new from figma,
  darkLayer0: '#18181a',
  darkLayer1: '#212124',
  darkLayer2: '#2a2a2f', // figma used #34343B but a bit too bright

  darkBorder1: '#34343b',
  darkBorder2: '#64646b',

  // Dashboard bg / layer 0 (light theme)
  gray90: '#f4f5f5',
  // Card bg / layer 1
  gray100: '#f4f5f5',
  // divider line
  gray80: '#d0d1d3',
  // from figma
  lightBorder1: '#e4e7e7',

  blueDarkMain: '#3d71d9', // '#4165F5',
  blueDarkText: '#6e9fff', // '#58a6ff', //'#33a2e5', // '#5790FF',
  redDarkMain: '#d10e5c',
  redDarkText: '#ff5286',
  greenDarkMain: '#1a7f4b',
  greenDarkText: '#6ccf8e',
  orangeDarkMain: '#ff9900',
  orangeDarkText: '#fbad37',

  blueLightMain: '#3871dc',
  blueLightText: '#1f62e0',
  redLightMain: '#e0226e',
  redLightText: '#cf0e5B',
  greenLightMain: '#1b855e',
  greenLightText: '#0a764e',
  orangeLightMain: '#ff9900',
  orangeLightText: '#b5510d',
};
